module.exports = __webpack_public_path__ + "img/796.3994c91d.png";